<template>

  <div id="top" class="section">

        
        <div class="col_a"></div>
        <div class="col_b"></div>
        <div class="col_c"></div>
        <div class="col_d">
        <img src="../assets/TITLE_white.svg" alt="TITLE" class="logo"> 
        
        
        </div>

  </div>
</template>

<style>
  #top{
  /* border: 3px solid rgb(255, 183, 0);  */
  position: relative;
  display: flex;
  background-size:cover; 
  background-repeat: no-repeat;
  background-position:50%;
  display: flex;
 
  justify-content: center;
  /* align-items:flex-end; */
  align-items:center;
  
  /* object-fit: cover; */
  width:100%;
  height: 67%;

  padding-bottom: 0vh;
  min-width: 320px;
  min-height: 400px;
  background-color: rgb(60, 59, 59);
  background-image: url('../assets/0529_0321.jpg'); 

}

.logo {
  /* border: 1px solid rgb(255, 21, 0); */

  /* top: 52%;             */
  right: 10%;            
  width: auto;
  height:100%;

  /* transform: translateY(-50%);  */
  z-index: 3;
  opacity: 0.85;
}

.col_a{
  /* border: 2px dashed rgb(98, 255, 0); */
  width:25vw;
  height: 100vh;
}
.col_b{
  /* border: 2px dashed rgb(0, 55, 255); */
  width:25vw;
  height: 100vh;
}
.col_c{
  /* border: 2px dashed rgb(255, 0, 157); */
  width:25vw;
  height: 65vh;
}
.col_d{
  /* border: 2px dashed rgb(238, 255, 0); */
  padding-top: 1vh;
  width:25vw;
  height: 65vh;
  min-height: 600px;
  min-width:150px;
}

</style>